<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Glass Colour';
                }
            },
            component_id: {
                default(){
                    return 'glass_colour';
                }
            },
            glassDesign: {
                required: true,
            },
            slab: {
                required: true,
            },
            primaryColour: {
                required: false,
                default() {
                    return '';
                }
            },
            target: {
                default: ''
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.glassDesign, this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/glass-colour?glass_design=' + this.glassDesign + '&slab=' + this.slab + '&primary_colour=' + this.primaryColour + '&secondary_colour=' + this.secondaryColour + '&fabricator_id=' + this.fabricator;
            },
            cache_key(){
                return '_' + this.glassDesign + '_' + this.slab + '_' + this.primaryColour + '_' + this.secondaryColour;
            },
        },
        watch: {
            'glassDesign': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'primaryColour': function (val, oldVal) {
                this.update_options();
            },
            'secondaryColour': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
